import { create } from 'zustand'

type RecognitionRefreshStore = {
  refreshKey: number
  triggerRefresh: () => void
}

export const useRecognitionRefreshStore = create<RecognitionRefreshStore>(set => ({
  refreshKey: 0,
  triggerRefresh: () => set(state => ({ refreshKey: state.refreshKey + 1 })),
}))
